import { render, staticRenderFns } from "./FoodGroceryComposition.vue?vue&type=template&id=2787da08&scoped=true"
import script from "./FoodGroceryComposition.vue?vue&type=script&lang=js"
export * from "./FoodGroceryComposition.vue?vue&type=script&lang=js"
import style0 from "./FoodGroceryComposition.vue?vue&type=style&index=0&id=2787da08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2787da08",
  null
  
)

export default component.exports